/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs */

const en_guide_json_vs_yaml_xml_s1_li2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>YAML</strong>: Human-readable, supports comments, popular for configuration files (Kubernetes, Docker Compose, GitHub Actions)`)
};

const ko_guide_json_vs_yaml_xml_s1_li2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>YAML</strong>: 사람이 읽기 쉬움, 주석 지원, 설정 파일에 인기(Kubernetes, Docker Compose, GitHub Actions)`)
};

const ja_guide_json_vs_yaml_xml_s1_li2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>YAML</strong>: 人間が読みやすい、コメント対応、設定ファイルで人気（Kubernetes、Docker Compose、GitHub Actions）`)
};

/**
* | output |
* | --- |
* | "<strong>YAML</strong>: Human-readable, supports comments, popular for configuration files (Kubernetes, Docker Compose, GitHub Actions)" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s1_li2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S1_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s1_li2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s1_li2(inputs)
	return ja_guide_json_vs_yaml_xml_s1_li2(inputs)
});